<div class="list-cities">
    <ul>
        <li *ngFor="let item of cities">
            <a [routerLink]="['/smart-city-profile', item.name+'-'+item.region+'-'+item.country, item.id]">
                <div class="row">
                    <div class="col-md">
                        <span><i class="ion ion-ios-arrow-forward"></i> {{item.name}}</span>
                    </div>
                    <div class="col-auto col">
                        <em>{{ (item.region) ? item.region + ', ' : '' }}{{item.country}}</em>
                    </div>
                </div>
            </a>
        </li>
    </ul>
</div>